exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-preview{margin-bottom:25px}.img-details h4{color:#797979;font-weight:300;font-size:22px;margin:0}.img-details .img-details--item+.img-details--item{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d32bc8a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/cms/media/MediaMain.vue
// module id = 0uSb
// module chunks = 0 1